<template>
    <div v-if="form_data">
        <recharge-wallet
                :form_data="form_data"
                :recharge_wallet="recharge_wallet"
        >
        </recharge-wallet>
        <update-wallet-settings
                v-if="$can('change-settings', 'open-banking')"
                :form_data="form_data"
                :submit_open_banking_settings="submit_open_banking_settings"
        >
        </update-wallet-settings>
        <update-general-subscription-setting
            v-if="$can('change-settings', 'open-banking')"
        >
        </update-general-subscription-setting>
    </div>
</template>

<script>
import $ from "jquery"
import {KTApp} from '@/plugins/core/app'
import {openBankingWalletService} from '@/common/api.service'
import {BASE_PATH} from '@/common/config'
import rechargeWallet from './recharge-wallet'
import updateWalletSettings from './update-wallet-settings'
import updateGeneralSubscriptionSetting from './update-general-subscription-setting.vue'
import {i18n} from '@/plugins/i18n'

export default {
    name: "openBankingWallet",

    components: {
        'recharge-wallet': rechargeWallet,
        'update-wallet-settings': updateWalletSettings,
        'update-general-subscription-setting': updateGeneralSubscriptionSetting,
    },
    data() {
        return {
            form_data: null
        }
    },
    mounted() {
        let getSettingsMethod;
        if (this.$can('change-settings', 'open-banking')) {
            getSettingsMethod = openBankingWalletService.getAdminSettings();
        } else {
            getSettingsMethod = openBankingWalletService.getSettings();
        }

        getSettingsMethod.then(response => {
            this.form_data = response.data.data

        }).catch(({response}) => {
            this.showMsg(form, 'danger', response.data.message)
        })
    },
    methods: {
        recharge_wallet(e) {

            let form = $('#recharge_wallet_form')
            let btn = $('#submit_btn_recharge_wallet')

            if ($('#recharge_price').val() < 10000) {
                return
            }

            KTApp.progress(btn)

            let params = {
                recharge_price: $('#recharge_price').val(),
            }
            openBankingWalletService.rechargeWallet(params).then(response => {
                let tracking_code = response.data.data.tracking_code
               window.location = BASE_PATH + '/open-banking/wallet/pay-recharge/' + tracking_code;
            }).catch(({response}) => {
                this.showMsg(form, 'danger', i18n.t('message.an_error_accord'))
            }).finally(() => {
                        KTApp.unprogress(btn)
                    }
            );
        },
        submit_open_banking_settings(e) {

            let form = $('#open_banking_settings_form')
            let btn = $('#submit_btn_open_banking_settings')
            KTApp.progress(btn)

            let params = {
                'recharge_gateway_id': this.form_data.recharge_gateway_id,
                'card_national_id_inquiry_price': this.form_data.card_national_id_inquiry_price,
                'mobile_national_id_inquiry_price': this.form_data.mobile_national_id_inquiry_price
            }

            openBankingWalletService.updateWalletSettings(params).then(response => {
                this.showMsg(form, 'success', response.data.message)
            }).catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message)
            }).finally(() => {
                        KTApp.unprogress(btn)
                    }
            );
        },
        submit_general_subscription_setting(e) {

            let form = $('#update_general_subscription_setting_form')
            let btn = $('#update_general_subscription_setting_btn')
            KTApp.progress(btn)

            let params = {
                'recharge_gateway_id': this.form_data.recharge_gateway_id,
                'card_national_id_inquiry_price': this.form_data.card_national_id_inquiry_price,
                'mobile_national_id_inquiry_price': this.form_data.mobile_national_id_inquiry_price
            }

            openBankingWalletService.updateWalletSettings(params).then(response => {
                this.showMsg(form, 'success', response.data.message)
            }).catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message)
            }).finally(() => {
                        KTApp.unprogress(btn)
                    }
            );
        },
    },
}
</script>

<style scoped>

</style>
